import { Injectable }       from '@angular/core';
import { CanLoad, Route, Router,CanActivate } from '@angular/router';
import {ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {MatDialog} from "@angular/material";
import {Api} from './api'
import {APPCONFIG} from "../config";

import {RestrictedAccessComponent} from '../layout/restrictedAccesss.component'

@Injectable()
export class AuthGuardService implements  CanLoad, CanActivate{
    constructor(private router: Router,private api:Api,private dialog: MatDialog) {
    }

    canLoad(route: Route): boolean {

        console.log("inside canLoad", route );
        if (localStorage.getItem(APPCONFIG.prefix + 'isLoggedIn') && localStorage.getItem(APPCONFIG.prefix + 'isLoggedIn') == 'true' ) {
             console.log("inside loading permission");
            return true;
        }
        console.log("user is not logged in for guard");
        return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // alert("activate route snap shot "  + ActivatedRouteSnapshot + " RouterStateSnapshot " + RouterStateSnapshot  ) ;
        let url: string = state.url;
        console.log('Url:'+ url);
        if (this.api.isloggedInUserAdmin() || this.checkIsUrlIsSaleOrder(url)) {
            console.log("activated Route");
            return true;
        }
        console.log("Deactivated Route");
        this.dialog.open(RestrictedAccessComponent);
        return false
    }

    checkIsUrlIsSaleOrder(url) {
        if(this.api.isloggedInUserSaleRep() && url === "/app/transactions/saleOrder"){
            return true
        }
        else
            return false
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/providers/auth-guard-service.ts